/* @flow */
import {
    FETCH_SESSION_SUCCESS,
    INJECT_ERROR,
    FETCH_API_ERROR,
    ACKNOWLEDGE_ERROR
} from 'common/constants/actionTypes';

import { type ErrorAction } from 'common/redux/actions/error';

import ErrorRecord from 'common/models/ErrorRecord';
import * as Immutable from 'immutable';
import { ErrorWithAutoAcknowldge } from 'common/modules/api';

export const error = (
    state = Immutable.fromJS({
        records: {},
        isAPIErrored: false
    }),
    action: ErrorAction
) => {
    switch (action.type) {
        case INJECT_ERROR: {
            const error = action.response;
            let isAutoAcknowledge;
            let autoAcknowledgeTimeout;
            if (error instanceof ErrorWithAutoAcknowldge) {
                isAutoAcknowledge = true;
                ({ autoAcknowledgeTimeout } = error);
            }
            const errorMsg = error.message;
            return state.setIn(
                ['records', errorMsg],
                new ErrorRecord({
                    message: errorMsg,
                    isAutoAcknowledge,
                    autoAcknowledgeTimeout
                })
            );
        }

        case FETCH_API_ERROR:
            return state.setIn(['isAPIErrored'], action.payload);

        case ACKNOWLEDGE_ERROR: {
            const error: Error = action.response;
            const errorFromStore: ?ErrorRecord = state.getIn([
                'records',
                error.message
            ]);
            // Can be undefined if called after FETCH_SESSION_SUCCESS
            return errorFromStore
                ? state.setIn(
                      ['records', error.message],
                      errorFromStore.set('isAcknowledged', true)
                  )
                : state;
        }

        case FETCH_SESSION_SUCCESS: {
            return Immutable.fromJS({ records: {} });
        }

        default:
            return state;
    }
};
